import { render, staticRenderFns } from "./AssetsAndLiabilities.vue?vue&type=template&id=2881b91c&scoped=true"
import script from "./AssetsAndLiabilities.vue?vue&type=script&lang=js"
export * from "./AssetsAndLiabilities.vue?vue&type=script&lang=js"
import style0 from "./AssetsAndLiabilities.vue?vue&type=style&index=0&id=2881b91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2881b91c",
  null
  
)

export default component.exports